import React, { useMemo } from 'react';
import TablaDoc from './TablaDoc';

/**
 * Qué paso del protocolo falla en cada consultor y qué se le instruye corregir.
 * La corrección viene del playbook al que quedó asignado, que se busca por clave.
 */
const TablaProtocolo = ({ correcciones, t }) => {
  const playbookPorClave = useMemo(() => {
    const mapa = {};
    (correcciones?.playbooks ?? []).forEach((b) => {
      mapa[b.clave] = b;
    });
    return mapa;
  }, [correcciones]);

  const columnas = [
    {
      label: t('ap_colConsultant'),
      ancho: '21%',
      render: (fila) => <strong>{fila.consultor}</strong>,
    },
    {
      label: t('ap_colStep'),
      ancho: '34%',
      render: (fila) => (
        <>
          <strong>{fila.titulo}</strong>
          <span className='ap-doc-parrafo'>{fila.justificacion}</span>
        </>
      ),
    },
    {
      label: t('ap_colCoaching'),
      ancho: '45%',
      render: (fila) => playbookPorClave[fila.clave]?.correccion_instruida ?? '',
    },
  ];

  return (
    <TablaDoc
      columnas={columnas}
      filas={correcciones?.asignacion_por_consultor ?? []}
      textoVacio={t('ap_noRows')}
    />
  );
};

export default TablaProtocolo;
